<!-- Filtres -->
@if (filters().length) {
  <button
    [matMenuTriggerFor]="menuFilter"
    #filterTrigger="matMenuTrigger"
    mat-button
    matTooltip="Filtrer (Alt+F)"
    class="tertiary"
  >
    <mat-icon>filter_alt</mat-icon>
  </button>
  <mat-menu #menuFilter="matMenu">
    <ng-template matMenuContent>
      <div class="w-[250px] px-4 py-3">
        <div class="flex flex-col">
          <div class="pb-2">
            <div class="flex gap-4">
              @if (currentFilterView() === 'main') {
                <div class="content-center font-semibold">Filtrer par</div>
              } @else {
                <button (click)="back(); $event.stopPropagation()" mat-button class="tertiary flax">
                  <mat-icon>arrow_back</mat-icon>
                </button>
                <div class="content-center">
                  {{ currentFilterView() | titlecase }}
                </div>
              }
            </div>
          </div>
          <mat-divider></mat-divider>

          @if (currentFilterView() === 'main') {
            @for (filter of filters(); track $index) {
              <button (click)="openSubmenu(filter.label); $event.stopPropagation()" mat-menu-item>
                {{ filter.label }}
              </button>
            }
            <mat-divider></mat-divider>
            <div class="mt-2 flex justify-center gap-6">
              <button (click)="clearFilter()" mat-stroked-button>Réinitialiser</button>
              <button
                [disabled]="mappedFilters()?.length === 0"
                (click)="doApplyFilter()"
                mat-flat-button
                class="primary"
              >
                Appliquer
              </button>
            </div>
          } @else if (currentFilterView() !== 'main') {
            <!-- ng content -->
            <ng-container *ngTemplateOutlet="filterTemplate()"></ng-container>
            <mat-divider></mat-divider>
            <div class="mt-2 flex justify-center gap-6">
              <button mat-stroked-button>Annuler</button>
              <button
                [disabled]="mappedFilters()?.length === 0"
                (click)="doApplyFilter()"
                mat-flat-button
                class="primary"
              >
                Appliquer
              </button>
            </div>
          }
        </div>
      </div>
    </ng-template>
  </mat-menu>
}
